import moment from 'moment';
import h from 'hyperscript';
import { generateIcon } from 'components/_particles/icon/icon';
import jump from 'jump.js';
import LoginHandler from 'javascripts/watcher/bp-user-actions';

export default class CommentPreview {
  constructor($trigger) {
    this.$trigger = $trigger;
    this.$formbox = this.$trigger.closest('.comment-list__box');
    this.$form = this.$formbox.querySelector('.form');
    this.userName = this.$formbox.getAttribute('data-user-name');
    this.commentNumber = this.$formbox.getAttribute('data-max-comment');
    this.$commentList = this.$trigger.closest('.comment-list');
    this.$commentControls = this.$commentList.querySelector('.comment-list__controls');
    this.$commentsEmpty = this.$commentControls && this.$commentControls.querySelector('.comment__text--empty');
    this.$subject = this.$formbox.querySelector('#subject');
    this.$text = this.$formbox.querySelector('#text');

    this.$trigger.addEventListener('click', this.showPreview);
  }

  showPreview = () => {
    const loginState = LoginHandler.getLoginState();
    // abort by triggering the loging in case the user is currently not logged in
    if (loginState === false) {
      this.formLink();
      return;
    }

    if (this.$subject && this.$text) {
      const config = {};
      // get current form-data
      config.subject = this.$subject.value;
      config.text = this.$text.value;
      config.user = this.userName ? this.userName : 'Ohne Name';

      // get current Date/time
      moment.locale('de');
      config.date = moment().format('DD.MM.YYYY');
      config.time = moment().format('HH:mm');

      // build preview
      this.$preview = this.buildPreview(config);
      this.$preview.setAttribute('tabindex', '1');
      this.$preview.classList.add('comment--highlighted');

      if (this.$commentControls) {
        this.$commentControls.parentNode.insertBefore(
          this.$preview,
          this.$commentControls.nextSibling,
        );

        if (this.$commentsEmpty) {
          this.$commentsEmpty.parentNode.removeChild(this.$commentsEmpty);
        }
        // jump to element
        jump(this.$preview, {
          offset: -30,
          duration: 350,
        });
        this.$preview.focus();

        // disable form
        this.$subject.disabled = true;
        this.$text.disabled = true;
        this.$trigger.disabled = true;

        const previewHeight = this.$preview.querySelector('.comment-list__textarea-preview').scrollHeight;
        this.$preview.querySelector('.comment-list__textarea-preview').style.height = `${previewHeight}px`;

        window.setTimeout(() => {
          this.$preview.classList.remove('comment--highlighted');
        }, 500);
      }
    }
  }

  formLink() {
    let textEncoded = '';
    let titleEncoded = '';

    if (this.$text.value) {
      textEncoded = encodeURIComponent(`?textComment=${this.$text.value}`);
    }

    if (this.$subject.value) {
      let selector = '?';
      if (this.$text.value) {
        selector = '&';
      }
      titleEncoded = encodeURIComponent(`${selector}titleComment= ${this.$subject.value}`);
    }

    const hrefLink = document.querySelector('#js-bp-login a').getAttribute('href');
    const link = `${hrefLink}${textEncoded}${titleEncoded}`;

    window.location.href = link;
  }

  handleEdit = () => {
    this.$preview.parentNode.removeChild(this.$preview);
    if (this.$commentsEmpty && this.$commentControls) {
      this.$commentControls.appendChild(this.$commentsEmpty);
    }

    // enable form
    this.$subject.disabled = false;
    this.$text.disabled = false;
    this.$trigger.disabled = false;

    // jump to form
    jump(this.$formbox, {
      offset: -30,
      duration: 350,
    });
    this.$subject.focus();
  }

  handleSubmit = () => {
    this.handleEdit();
    this.$trigger.disabled = true;
    this.$form.submit();
    setTimeout(() => {
      // reenable preview-button after 8
      this.$trigger.disabled = false;
    }, 8000);
  }

  buildPreview(content) {
    const {
      subject,
      text,
      user,
      date,
      time,
    } = content;
    const $subjectContent = subject === '' ?
      h('span.comment__headline--empty', 'Der Betreff ist leer') : subject;

    const $textContent = text === '' ?
      h('span.comment__text--empty', 'Ihr Kommentar ist leer.') : text;

    const $commentMeta = h(
      '.comment__meta',
      h(
        '.comment__author.comment__author-badge',
        generateIcon({ icon: 'profile', className: 'comment__badge-icon' }),
        h('span.comment__author-name', user),
      ),
      h(
        'time.comment__date-time', { datetime: `${date} ${time}` },
        generateIcon({ icon: 'calendar', className: 'comment__meta-icon' }),
        date,
        generateIcon({ icon: 'clock', className: 'comment__meta-icon' }),
        time,
      ),
    );

    const $commentBody = h(
      '.comment__body',
      h(
        '.comment__headline',
        h('.comment__preview-kicker', 'Vorschau'),
        h('h4.headline.headline--4', $subjectContent),
      ),
      h(
        '.comment__text',
        h('textarea.input.input--multiple.comment-list__textarea-preview', { disabled: 'disabled' }, $textContent),
      ),
    );

    const $commentFooter = h(
      '.comment__footer',
      h(
        '.comment__tools',
        h(
          '.comment__function',
          h(
            'button#comment-edit.button.button--secondary', {
              onclick: this.handleEdit,
            },
            h('span.button__text', 'Bearbeiten'),
          ),
        ),
        h(
          '.comment__function',
          h(
            'button#comment-publish.button.button--primary', {
              onclick: this.handleSubmit,
            },
            h('span.button__text', 'Veröffentlichen'),
          ),
        ),
      ),
    );

    return h(
      'article.comment',
      $commentMeta,
      $commentBody,
      $commentFooter,
    );
  }
}
